<fin-benefit-banner
  *ngIf="sidebar$ | async as sidebar"
  [title]="sidebar.teaserTitle"
  [buttons]="cta$ | async"
  [invertedColors]="invertedColors"
>
  <div sideContent>
    <cms-unstyled-fragment [cmsContent$]="sidebar | finToObservable" [showTitle]="false"></cms-unstyled-fragment>
    <ng-container *ngIf="sidebar | finMap: 'media.0' as image">
      <div class="ms-xsmall-t image-wrapper dn-laptop-up center">
        <fcom-image [scale]="false" [imageData]="sidebar | finMap: 'media.0'"></fcom-image>
      </div>
      <div class="ms-xsmall-t image-wrapper dn-laptop-down">
        <fcom-image [scale]="false" [imageData]="sidebar | finMap: 'media.0'"></fcom-image>
      </div>
    </ng-container>
  </div>
  <ng-container>
    <fin-tier-benefits [invertedColors]="invertedColors" [items]="articles$ | async"></fin-tier-benefits>
  </ng-container>
</fin-benefit-banner>
